<template>
  <div class="body-box marginBox">
    <!-- 搜索与添加区域 -->
    <el-row class="plan">
      <el-col :span='24'>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="球 场" name="COURT"></el-tab-pane>
          <el-tab-pane label="旅 行" name="TRAVEL"></el-tab-pane>
          <el-tab-pane label="商 品" name="GOODS"></el-tab-pane>
          <el-tab-pane label="全 部" name="ALL"></el-tab-pane>
        </el-tabs>
      </el-col>

      <el-col :span="18">
        <el-button icon="el-icon-plus" @click="addSale">新增</el-button>
      </el-col>

      <el-col :span="5">
        <search-input v-model="queryInfo.keyword" placeholder="请输入关键字进行搜索" @change="handleQuery" />
      </el-col>

    </el-row>


    <el-table :height="'calc(100% - 120px)'" :data="saleList" class="button-box">
      <el-table-column label="缩略图" prop="thumbnail">
        <template slot-scope="scope">
          <icon-img :icon="scope.row.thumbnail"></icon-img>
        </template>
      </el-table-column>
      <el-table-column label="名称" prop="name"></el-table-column>
      <el-table-column label="原价" prop="cost"></el-table-column>
      <el-table-column label="现价" prop="price"></el-table-column>
      <el-table-column label="开始时间" prop="startTime">
        <template slot-scope="scope">
          {{scope.row.startTime | formatDate('yyyy-MM-dd hh:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column label="结束时间" prop="endTime">
        <template slot-scope="scope">
          {{scope.row.endTime | formatDate('yyyy-MM-dd hh:mm:ss')}}
        </template>
      </el-table-column>
      <el-table-column label="是否启用" prop="enumState">
        <template slot-scope="scope">
          {{scope.row.enumState === 'NORMAL' ? '是' : '否'}}
        </template>
      </el-table-column>
      <el-table-column label="优惠包类型" prop="enumType">
        <template slot-scope="scope">
          {{scope.row.enumType | SaleType}}
        </template>
      </el-table-column>
      <el-table-column label="排序" prop="resort"></el-table-column>
      <el-table-column label="操作" min-width="100" fixed="right">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="click">
            <div class="foldBtnBox">
              <div><el-button icon="el-icon-edit" @click="edtiSale(scope.row)">修改</el-button></div>
              <div><el-button icon="el-icon-delete" @click="removeSaleById(scope.row.id)">删除</el-button></div>
            </div>
            <el-button slot="reference">更多操作</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页区域 -->
    <div class="fixedBox"><pagination ref="page" :query-param.sync='queryInfo' @pagination="getSaleList" /></div>


    <addSale @refresh-list="handleQuery" ref="addSale"></addSale>
    <editSale @refresh-list="handleQuery" ref="editSale"></editSale>
  </div>
</template>
<script>
import Pagination from '@/components/common/Pagination/index'
import addSale from '@/views/sale/addSale'
import editSale from '@/views/sale/editSale'
import { getPostOrDeleteData } from '@/utils/code'
import { deleteSale, getSaleBackList } from '@/api/sale/sale'
import { deleteTips, title } from '@/utils/tips'
import SearchInput from '@/components/common/searchInput/searchInput'
import IconImg from '@/components/common/pictureImg/index'

export default {
  components: { IconImg, SearchInput, Pagination, addSale, editSale },
  data() {
    return {
      queryInfo: {
        keyword: '',
        type: ''
      },
      saleList: [],
      activeName: 'ALL'
    }
  },

  watch: {
    queryInfo(newData) {
      this.activeName = newData.type === '' ? 'ALL' : newData.type
    }
  },

  mounted() {
    this.handleQuery()
  },

  methods: {
    searchSaleType(type) {
      this.queryInfo.type = type
      this.handleQuery()
    },

    //tab切换
    handleClick(tab) {
      this.queryInfo.type = tab.name === 'ALL' ? '' : tab.name
      this.handleQuery()
    },

    //查询列表
    getSaleList(page, cb) {
      getSaleBackList(page).then((response) => {
        this.saleList = cb(response)
      })
    },

    //根据ID删除数据
    async removeSaleById(id) {
      let b = await deleteTips(title.deleteTitle)
      if (b) {
        deleteSale(id).then((response) => {
          let data = getPostOrDeleteData(response)
          if (data !== null) {
            this.handleQuery()
          }
        })
      }
    },

    //新增
    addSale() {
      this.$refs.addSale.addDialog()
    },

    //修改
    edtiSale(row) {
      this.$refs.editSale.editDialog(row)
    },

    //查询按钮
    handleQuery() {
      this.$nextTick(() => {
        this.$refs.page.run()
      })
    }

  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog {
  padding-right: 30px;
}
</style>
